import router from '../../../router'

/* eslint-disable no-unused-expressions */
const emptyDialog = () => ({
  message: '',
  title: '',
  cancelText: '',
  okText: '',
  ok: null,
  cancel: null,
  type: 'confirm',
  reverseColors: false,
  titleColor: '',
})
const setNextDialog = (state) => {
  state.dialogs.pop()
}
const getCurrentDialog = state => state.dialogs[state.dialogs.length - 1]
const confirmDialog = {
  state: {
    dialogs: []
  },
  getters: {
    confirmDialog: state => getCurrentDialog(state)
  },
  mutations: {
    hideConfirmDialog: (state) => {
      getCurrentDialog(state)?.cancel?.()
      setNextDialog(state)
    },
    confirmDialogOkClick: state => {
      getCurrentDialog(state)?.ok?.()
      setNextDialog(state)
    },
    addConfirmDialog: (state, dialog) => {
      state.dialogs.push(dialog)
    }
  },
  actions: {
    async confirmDialog ({ commit }, {
      title, message, okText, cancelText, ok, cancel, type, reverseColors, titleColor,
    }) {
      const dialog = {
        ...emptyDialog(),
        title,
        message,
        okText,
        cancelText,
        ok,
        cancel,
        type: type || 'confirm',
        reverseColors: reverseColors || false,
        titleColor: titleColor || '',
      }
      commit('addConfirmDialog', dialog)
    },
    async tvpPrePaymentConfirm ({ commit, dispatch }) {
      dispatch('confirmDialog', {
        message: '宿泊料金を上回ったTVP数が登録されています。 利用指定TVP数をすべて消費するようTVP数を変更してください。',
        okText: '請求画面へ移動',
        ok: () => {
          router.push({
            path: '/reservation/contract-detail',
            query: {
              id: router.currentRoute.query.id,
              tab: 'billing-statement'
            }
          })
        },
        cancelText: 'この画面に留まる'
      })
    }
  }
}

export default confirmDialog
